<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Tank Shift</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <!-- breadcrumb End -->
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Tank Shift</span>
        </div>
        <div class="Reports_form_div">
          <form class="form-horizontal" id="myForm" role="form" novalidate [formGroup]="registerForm">
            <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
              <mat-form-field appearance="outline" class="w-100 custom-select" *ngIf="loginPersonType == 'EMPLOYEE'">
                <mat-label>Search Business Name</mat-label>
                <!-- search box powered by mat‑autocomplete -->
                <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield" placeholder="Search business" (keyup)="filterBusinesses($event)"
                       (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntities" [matAutocomplete]="businessAuto"/>
                <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                  <mat-option *ngFor="let option of filteredOptions" [value]="option">
                    {{ option.businessName }}
                  </mat-option>
                </mat-autocomplete>
                <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
                <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
                <mat-error *ngIf="(shiftDetailSubmitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                  <i *ngIf="f.businessfield.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Farm Site</mat-label>
                <mat-select id="location" formControlName="locationField" name="location" (click)="isDropdownOpen = false" [(ngModel)]="feedLog.farm_site_id" [disabled]="formReadonly"
                            (selectionChange)="handelGotoButton(); handelGotoButton(); percentage = 0; confirmHideShow = false; feedLog.source_section_id = undefined; feedLog.source_tank_id = undefined; feedLog.destination_tank_id = undefined; feedLog.destination_section_id = undefined; percentageCal = false; goToConfirm = false; feedLog.source_tank_id = undefined; displayTanks = false; shiftDetailSubmitted=false">
                  <mat-option value="undefined" disabled>Select Farm site</mat-option>
                  <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                    {{ (farmsite?.farmNameAtLocation)}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
                <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
                <mat-error *ngIf="(shiftDetailSubmitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                  <i *ngIf="f.locationField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
            </div>
          </form>
          <div class="buttons-div reports_search_div">
            <div class="transactions-button-container" (click)="goTo()">
              <button class="transaction-submit-button" [disabled]="formReadonly">
                <span class="goicon"><img src="../../../../../assets/images/New_Icons/go.svg"></span>
                <span class="text">Go</span>
              </button>
            </div>
          </div>
        </div>
        <form [formGroup]="shiftDetailsForm">
          <div *ngIf="displayTanks">
            <div class="shiftheading">Shift</div>
            <!--<div class="shiftInfo">Enter latest sampling record in Blubay Before shift <img
              src="../../../../../assets/img/info.png" height="20" width="20"/></div>-->
            <div class="row">
              <div class="info-container">
                <img src="../../../../../assets/images/New_Icons/info-icon.svg" height="20" width="20"/>
                <span>Enter latest sampling record in Blubay Before shift</span>
              </div>
            </div>
            <div class="reports-form-container shift-form-container">
              <!--from label-->
              <div class="form-field shift-field">
                <label style="left: 0">From</label>
              </div>
              <div class="form-field shift-field"></div>
              <img src="../../../../../assets/img/ic_Shift.png" height="25" width="25"
                   class="arrowImage current-count-block"/>
              <!--to label-->
              <div class="form-field shift-field">
                <label style="left: 0">To</label>
              </div>
              <div class="form-field shift-field"></div>
              <!--From section-->
              <mat-form-field appearance="outline" class="w-100 shift-form-field">
                <mat-label>Section</mat-label>
                <mat-select id="fromsection" formControlName="fromsection" name="fromsection" (click)="isDropdownOpen = false" [(ngModel)]="feedLog.source_section_id" [disabled]="formReadonly"
                            (selectionChange)="getPondsBySectionId('From'); feedLog.source_tank_id = undefined; sourceAnimals = 0;">
                  <mat-option value="undefined" disabled>Select Section</mat-option>
                  <mat-option *ngFor="let section of sourceSections" [value]="section.id">
                    {{ section.section_name}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f1.fromsection.invalid"><i>Select section</i></mat-hint>
                <mat-hint *ngIf="f1.fromsection.valid"><i>Section selected</i></mat-hint>
                <mat-error *ngIf="(shiftDetailSubmitted || f1.fromsection.touched || f1.fromsection.dirty) && f1.fromsection.errors">
                  <i *ngIf="f1.fromsection.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <!--from tank-->
              <mat-form-field appearance="outline" class="w-100 shift-form-field">
                <mat-label>Tank</mat-label>
                <mat-select id="fromTankId" formControlName="fromTankId" name="fromTankId" (click)="isDropdownOpen = false" [(ngModel)]="feedLog.source_tank_id" [disabled]="formReadonly"
                            (selectionChange)="selectedSourceTankAnimals(); SelectedSourcePondPercentage(); ">
                  <mat-option value="undefined" disabled>Select Section</mat-option>
                  <mat-option [hidden]="feedLog.destination_tank_id == pond.pond_id" *ngFor="let pond of source_pondsDetails_dropdown" [value]="pond.pond_id">
                    {{ pond.pond_name}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f1.fromTankId.invalid"><i>Select tank</i></mat-hint>
                <mat-hint *ngIf="f1.fromTankId.valid"><i>Tank selected</i></mat-hint>
                <mat-error *ngIf="(shiftDetailSubmitted || f1.fromTankId.touched || f1.fromTankId.dirty) && f1.fromTankId.errors">
                  <i *ngIf="f1.fromTankId.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <img src="../../../../../assets/img/ic_Shift.png" height="25" width="25" class="arrowImage"/>
              <!--To section-->
              <mat-form-field appearance="outline" class="w-100 shift-form-field">
                <mat-label>Section</mat-label>
                <mat-select id="dessection" formControlName="dessection" name="dessection" (click)="isDropdownOpen = false" [(ngModel)]="feedLog.destination_section_id" [disabled]="formReadonly"
                            (selectionChange)="getPondsBySectionId('To'); destinationAnimals = 0; feedLog.destination_tank_id = undefined">
                  <mat-option value="undefined" disabled>Select Section</mat-option>
                  <mat-option *ngFor="let section of sourceSections" [value]="section.id">
                    {{ section.section_name}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f1.dessection.invalid"><i>Select section</i></mat-hint>
                <mat-hint *ngIf="f1.dessection.valid"><i>Section selected</i></mat-hint>
                <mat-error *ngIf="(shiftDetailSubmitted || f1.dessection.touched || f1.dessection.dirty) && f1.dessection.errors">
                  <i *ngIf="f1.dessection.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <!--To tank-->
              <mat-form-field appearance="outline" class="w-100 shift-form-field">
                <mat-label>Tank</mat-label>
                <mat-select id="toTankId" formControlName="toTankId" name="toTankId" (click)="isDropdownOpen = false" [(ngModel)]="feedLog.destination_tank_id" [disabled]="formReadonly"
                            (selectionChange)="selectedDestinationTankAnimals();">
                  <mat-option value="undefined" disabled>Select Section</mat-option>
                  <mat-option [hidden]="feedLog.source_tank_id == pond.pond_id" *ngFor="let pond of destination_pondsDetails_dropdown" [value]="pond.pond_id">
                    {{ pond.pond_name}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f1.toTankId.invalid"><i>Select tank</i></mat-hint>
                <mat-hint *ngIf="f1.toTankId.valid"><i>Tank selected</i></mat-hint>
                <mat-error *ngIf="(shiftDetailSubmitted || f1.toTankId.touched || f1.toTankId.dirty) && f1.toTankId.errors">
                  <i *ngIf="f1.toTankId.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <!--From current count-->
              <div class="form-field shift-field">
                <label style="left: 0">Current Animal
                  Count: {{ (sourceAnimals ? sourceAnimals : 0) | currencyFormat }}</label>
              </div>
              <div class="form-field shift-field"></div>
              <img src="../../../../../assets/img/ic_Shift.png" height="25" width="25"
                   class="arrowImage current-count-block"/>
              <!--To current count-->
              <div class="form-field shift-field">
                <label style="left: 0">Current Animal
                  Count: {{ (destinationAnimals ? destinationAnimals : 0) | currencyFormat }}</label>
              </div>
              <!--Enter count-->
              <mat-form-field appearance="outline" class="w-100 shift-form-field">
                <mat-label>Count</mat-label>
                <input matInput type="text" id="count" autocomplete="off" formControlName="count" placeholder=""
                       [(ngModel)]="feedLog.shifted_animals" (keypress)="numberValidation($event)" (keyup)="SelectedSourcePondPercentage()" [disabled]="formReadonly"/>
                <mat-hint><i>2-4 digits</i></mat-hint>
                <mat-error *ngIf="shiftDetailSubmitted && f1.count.hasError('required')">
                  <i>Required.</i>
                </mat-error>
                <mat-error *ngIf="shiftDetailSubmitted && f1.count.hasError('pattern')">
                  <i>Enter valid count.</i>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="reports-form-container shift-form-container" *ngIf="percentageCal">
            <div class="form-field shift-field-percentage">
              <label style="left: 0">Feed and Treatment reduced percentage: {{ percentage }}%</label>
            </div>
            <div class="form-field shift-field"></div>
            <div class="form-field shift-field-percentage">
              <label style="left: 5px">Feed and Treatment transferred percentage: {{ percentage }}%</label>
            </div>
          </div>
          <div class="reports-form-container shift-form-density" *ngIf="responseFeedLog && cancelButton">
            <div class="form-field shift-field-percentage">
              <label
                style="left: 0">Density: {{ responseFeedLog && responseFeedLog.cultureDetailsUpdateStatus && responseFeedLog.cultureDetailsUpdateStatus.sourceDencity | currencyFormat }}</label>
            </div>
            <div class="form-field shift-field"></div>
            <div class="form-field shift-field-percentage">
              <label
                style="left: 10px">Density: {{ responseFeedLog && responseFeedLog.cultureDetailsUpdateStatus && responseFeedLog.cultureDetailsUpdateStatus.destinationDencity | currencyFormat }}</label>
            </div>
            <div class="form-field shift-field-percentage">
              <label style="left: 0">Feed
                Cumulative: {{ (responseFeedLog && responseFeedLog.sourceCumulativeFeed / 1000) | currencyFormat }}</label>
            </div>
            <div class="form-field shift-field"></div>
            <div class="form-field shift-field-percentage">
              <label style="left: 10px">Feed
                Cumulative: {{ (responseFeedLog && responseFeedLog.destinationCumulativeFeed / 1000) | currencyFormat }}</label>
            </div>
          </div>
        </form>
        <div class="col-lg-12" *ngIf="goToConfirm" style="padding-bottom: 30px;">
          <div class="buttons-div reports_search_div confirm-button">
            <div class="transactions-button-container" (click)="shift()">
              <button class="transaction-submit-button" [ngClass]="{'btnHide' : confirmHideShow}"
                      [disabled]="submitButtonDisabled">
                <span class="icon"><img src="../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                <span class="text">Confirm</span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-12" *ngIf="cancelButton" style="padding-bottom: 30px;">
          <div class="buttons-div reports_search_div">
            <div class="transactions-button-container" (click)="closeForm()">
              <button class="transaction-submit-button">
                <span class="goicon"><img src="../../../../../assets/images/New_Icons/back.svg"></span>
                <span class="text">Back</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
